import { Grid } from '@material-ui/core';
import {
  EntityApiDefinitionCard,
  EntityConsumingComponentsCard,
  EntityProvidingComponentsCard,
} from '@backstage/plugin-api-docs';
import {
  EntityAboutCard,
  EntityLayout,
  //EntityLinksCard,
} from '@backstage/plugin-catalog';
import { EntityWarningContent } from './modules/EntityWarningContent';

function Overview() {
  return (
    <Grid container spacing={3} alignItems="stretch">
      <EntityWarningContent />
      
      {/* Left column - 9 width */}
      <Grid item xs={12} md={8}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <EntityConsumingComponentsCard />
          </Grid>
          <Grid item xs={12}>
            <EntityProvidingComponentsCard />
          </Grid>
        </Grid>
      </Grid>

      {/* Right column - 3 width */}
      <Grid item xs={12} md={4}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <EntityAboutCard />
          </Grid>

        </Grid>
      </Grid>
    </Grid>
  );
}

export const apiPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Overview />
    </EntityLayout.Route>

    <EntityLayout.Route path="/definition" title="Definition">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <EntityApiDefinitionCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
